const e = 160, a = 180, n = "35px", o = "320px", t = "640px", c = "960px", s = "1280px", r = "8px", p = "16px", i = "4px", b = "0.5rem", m = "#0C2A4DCC", S = "0.25rem", x = "0.5rem", k = "640px", B = "960px", l = "1280px", d = "0.5rem";
export {
  t as a,
  o as b,
  c,
  s as d,
  a as e,
  e as f,
  k as g,
  B as h,
  l as i,
  n as j,
  x as k,
  S as l,
  m,
  d as n,
  b as o,
  i as p,
  r as q,
  p as r
};
